// components/PiecesIdentiteNewComponent/PiecesIdentiteNewComponent.tsx
import './style.scss';

import React, {FC, useContext, useEffect, useState} from "react";
import { DocumentUnion } from "shared/types/types";
import { ReactComponent as IconChevronDown } from "../../assets/img/icons/icon_carret-Down.svg";
import { ReactComponent as IconChevronUp } from "../../assets/img/icons/icon_carret-Up.svg";
import { ReactComponent as IconShield } from "../../assets/img/icons/icon_shield-Locked.svg";
import { ReactComponent as IconCardIdSmall } from "../../assets/img/icons/icon_card_id_small.svg";
import { ReactComponent as IconPassportSmall } from "../../assets/img/icons/icon_passport_small.svg";
import { ReactComponent as IconDriverLicenceSmall } from "../../assets/img/icons/icon_driver_licence_small.svg";
import { ReactComponent as IconResidencyPermitSmall } from "../../assets/img/icons/icon_residency_permit_small.svg";
import { ReactComponent as IconEmailSmall } from "../../assets/img/icons/icon_email_small.svg";
import { ReactComponent as IconPhoneNumberSmall } from "../../assets/img/icons/icon_phone_number_small.svg";
import { ReactComponent as IconCalendarSmall } from "../../assets/img/icons/icon_calendar_small.svg";
import { ReactComponent as IconCalendar2Small } from "../../assets/img/icons/icon_calendar2_small.svg";
import { ReactComponent as IconClose } from "../../assets/img/icons/icon_Close.svg";
import { ReactComponent as IconVirusSmall } from "../../assets/img/icons/icon_virus_small.svg";
import { ReactComponent as IconIbanSmall } from "../../assets/img/icons/payment/payStep.svg";
import { ReactComponent as IconAddressSmall } from "../../assets/img/icons/icon_Accompagnement.svg";
import { ReactComponent as IconSocialSecuritySmall } from "../../assets/img/icons/icon_coodonnee.svg";
import { ReactComponent as IconPasswordSmall } from "../../assets/img/icons/icon_Password.svg";
import { ReactComponent as IconEdit } from "../../assets/img/icons/icon_Edit.svg";
import { ReactComponent as IconTrash } from "../../assets/img/icons/icon_Trash.svg";

import coverIDTrackerVideo1 from "../../assets/img/coverIDTrackerVideo1.png";
import coverIDTrackerVideo2 from "../../assets/img/coverIDTrackerVideo2.png";

import DocumentCard from "../DocumentCard";
import Table from "../Table";
import { DocumentsContext } from "features/documents";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "features/account";
import { formatDocumentType, joursRestants } from "../../utils/utils";
import SelectedRowsActions from "../SelectedRowsActions";
import EmptyContent from "../EmptyContent";
import NotificationsList from "../NotificationsList";
import { getSubscription } from "features/account";
import { ReactComponent as IconVerified } from "../../assets/img/icons/icon_status-Verified.svg";
import { ReactComponent as IconWarning } from "../../assets/img/icons/icon_status-Warning.svg";
import Modal from "shared/ui/Modal";
import VideoFrame from "shared/ui/VideoFrame";
import Timeline from "../Timeline/Timeline";
import { BreachStatus, ClientDataBreached } from "features/breaches";
import { PersonalDataContext } from "features/personal-data";
import { PersonalData, PersonalDataType } from "features/personal-data";
import FAQ from "../FAQ";
import { faqDataIDTracker } from "../FAQ/faqData";
import TutorialCard from "../TutorialSection/TutorialSection";
import { BreachesContext } from "features/breaches";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { ReactComponent as IconAdd } from "../../assets/img/icons/icon_Plus.svg";
import ModalAddNewPersonalData from "../ModalAddNewPersonalData";
import personalData from "features/personal-data/pages/PersonalData/PersonalData";
import { encryptApiBodyFromStringWordPress } from "shared/api/cryptApiBody";


const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const columns = [
  { key: "number", label: "NUMÉRO" },
  { key: "dateExpiration", label: "EXP" },
  { key: "status", label: "STATUT" },
  { key: "nationality", label: "" },
  { key: "isBlocked", label: "" },
];

const columnsForExp = [
  { key: "number", label: "NUMÉRO" },
  { key: "dateExpiration", label: "EXP" },
  { key: "remainDateExp", label: "Jour Restant" },
];

// Types de documents pour le regroupement
const DOCUMENT_TYPES = {
  'CARTE_IDENTITE': 'Carte d\'identité',
  'PASSEPORT': 'Passeport',
  'TITRE_SEJOUR': 'Titre de séjour',
  'PERMIS_CONDUIRE': 'Permis de conduire'
};

// Types de personalData pour le regroupement - MIS À JOUR
const PERSONAL_DATA_TYPES = {
  'email': 'Adresse email',
  'phoneNumber': 'Numéro de téléphone',
  'iban': 'IBAN',
  'address': 'Adresse postale',
  'socialSecurityNumber': 'Numéro de sécurité sociale',
  'password': 'Mot de passe'
};

// Icônes pour chaque type de donnée personnelle
const PERSONAL_DATA_ICONS = {
  'email': <IconEmailSmall width={15} height={15} />,
  'phoneNumber': <IconPhoneNumberSmall width={15} height={15} />,
  'iban': <IconIbanSmall width={15} height={15} fill={"#12164D"} />,
  'address': <IconAddressSmall width={15} height={15} fill={"#12164D"} />,
  'socialSecurityNumber': <IconSocialSecuritySmall width={15} height={15} fill={"#12164D"} />,
  'password': <IconPasswordSmall width={15} height={15} />
};

// Messages vides pour chaque type
const PERSONAL_DATA_EMPTY_MESSAGES = {
  'email': "Si vous avez une adresse email, elle semble ne pas avoir encore été ajoutée et protégée par nos outils",
  'phoneNumber': "Si vous avez un numéro de téléphone, il semble ne pas avoir encore été ajouté et protégé par nos outils",
  'iban': "Si vous avez un IBAN, il semble ne pas avoir encore été ajouté et protégé par nos outils",
  'address': "Si vous avez une adresse postale, elle semble ne pas avoir encore été ajoutée et protégée par nos outils",
  'socialSecurityNumber': "Si vous avez un numéro de sécurité sociale, il semble ne pas avoir encore été ajouté et protégé par nos outils",
  'password': "Si vous avez un mot de passe, il semble ne pas avoir encore été ajouté et protégé par nos outils"
};

// Titres pour chaque type
const PERSONAL_DATA_TITLES = {
  'email': 'Adresse email',
  'phoneNumber': 'Numéro de téléphone',
  'iban': 'IBAN',
  'address': 'Adresse postale',
  'socialSecurityNumber': 'Numéro de sécurité sociale',
  'password': 'Mot de passe'
};

interface DocumentSectionProps {
  title: string;
  documents: DocumentUnion[];
  isExpanded: boolean;
  onToggle: () => void;
  isEmpty?: boolean;
  emptyMessage?: string;
  showProtectButton?: boolean;
  selectedRows: DocumentUnion[];
  onSelectionChange: (rows: DocumentUnion[]) => void;
  selectable: boolean;
  icon?: any;
}

// Ajoutez cette fonction pour compter les fuites par valeur
const getBreachCountForValue = (type: string, value: string, breaches: any[]): string => {
  if (!breaches || breaches.length === 0) {
    return '-';
  };

  // Pour les emails, on cherche dans les breaches
  if (type === 'email') {
    // Compter combien de breaches concernent cet email
    // On suppose que les breaches ont une relation avec ClientDataBreached
    const count = breaches.filter(breach => {
      // Vérifier si cette fuite concerne l'email
      // Selon votre structure de données, vous pouvez avoir besoin d'adapter
      return breach.email === value
    }).length;

    return count > 0 ? count.toString(): '-';
  }

  // Pour les autres types, on peut compter les fuites associées
  // Adaptez selon votre logique métier
  return '-';
};


export const DocumentSection: FC<DocumentSectionProps> = ({
  title,
  documents,
  isExpanded,
  onToggle,
  isEmpty = false,
  emptyMessage,
  showProtectButton = false,
  onSelectionChange,
  selectedRows,
  selectable = true,
  icon,
}) => {
  return (
    <div className="document-section">
      <div
        className="section-header"
        onClick={onToggle}
      >
        <div className={"d-flex flex-row gap-1"}>
          <span
            className="section-title text-initial text-secondary d-flex gap-1 flex-row justify-content-center align-items-center"
          >
            {icon && (
              icon
            )}
            <div className={"d-flex flex-column"}>
              <span>{title}</span>
              <span className={"text-xs font-regular text-muted-foreground"}>
                {documents.length} {`élément ${documents.length > 1 ? 's ' : ' ' }`}
              </span>
            </div>
        </span>
        </div>
        <div className="section-chevron d-flex flex-row align-items-center gap-05">
          <span className={"rounded-full bg-primary-70 px-2"}>{documents.length}</span>
          {isExpanded ? (
            <IconChevronUp width={12} height={12} fill="#171C60" />
          ) : (
            <IconChevronDown width={12} height={12} fill="#171C60" />
          )}
        </div>
      </div>

      {((!isEmpty && isExpanded)) ? (
        <div className="section-content">
          {isMobile ? (
            <div className="mobile-content">
              {documents.map((document: DocumentUnion) => (
                <div key={document.id} className="document-card-wrapper">
                  <DocumentCard document={document} hideTypeDoc={true}/>
                </div>
              ))}
            </div>
          ) : (
            <div className="desktop-content">
              <Table
                columns={columns}
                rows={documents}
                onSelectionChange={onSelectionChange}
                selectedRows={selectedRows}
                size="sm"
                selectable={selectable}
              />
            </div>
          )}
        </div>
      ) :  ( isExpanded && (<div className="empty-section-content">
          <p className="empty-message">{emptyMessage}</p>
          {showProtectButton && (
            <div className="protect-button-container">
              <button className="btn-protect-document">
                PROTÉGER CE DOCUMENT +
              </button>
            </div>
          )}
        </div>
      ))

      }

    </div>
  );
};

interface PersonalDataSectionProps {
  title: string;
  personalDatas: PersonalData[];
  isExpanded: boolean;
  onToggle: () => void;
  isEmpty?: boolean;
  emptyMessage?: string;
  showProtectButton?: boolean;
  selectedRows: PersonalData[];
  onSelectionChange: (rows: PersonalData[]) => void;
  selectable: boolean;
  breaches: any;
  icon?: any;
  onAdd?: () => void;
  onEdit?: (personalData: PersonalData) => void;
  onDelete?: (id: number) => void;
}

export const PersonalDataSection: FC<PersonalDataSectionProps> = ({
  title,
  personalDatas,
  isExpanded,
  onToggle,
  isEmpty = false,
  emptyMessage,
  showProtectButton = false,
  breaches,
  onSelectionChange,
  selectedRows,
  selectable = true,
  icon,
  onAdd,
  onEdit,
  onDelete,
}) => {
  const navigate = useNavigate();

  // Masquer partiellement les valeurs sensibles
  const maskValue = (type: string, value: string): string => {
    if (type === 'password') {
      return '•'.repeat(Math.min(value.length, 10));
    }
    if (type === 'iban') {
      return value.slice(0, 4) + ' •••• •••• •••• ' + value.slice(-4);
    }
    if (type === 'socialSecurityNumber') {
      return value.slice(0, 3) + ' •• •• ••• ••• ' + value.slice(-2);
    }
    return value;
  };

  // Récupérer la classe CSS en fonction du type
  const getTypeClassName = (type: string): string => {
    switch (type) {
      case 'email':
        return 'personal-data-card--email';
      case 'phoneNumber':
        return 'personal-data-card--phone';
      case 'iban':
        return 'personal-data-card--iban';
      case 'address':
        return 'personal-data-card--address';
      case 'socialSecurityNumber':
        return 'personal-data-card--social';
      case 'password':
        return 'personal-data-card--password';
      default:
        return '';
    }
  };

  return (
    <div className="document-section">
      <div
        className="section-header"
        onClick={onToggle}
      >
        <div className={"d-flex flex-row gap-1"}>
          <span
            className="section-title text-initial text-secondary d-flex gap-1 flex-row justify-content-center align-items-center"
          >
            {icon && icon}
            <div className={"d-flex flex-column"}>
              <span>{title}</span>
              <span className={"text-xs font-regular text-muted-foreground"}>
                {personalDatas.length} {`élément${personalDatas.length > 1 ? 's ' : ' ' }`}
              </span>
            </div>
          </span>
        </div>
        <div className="section-chevron d-flex flex-row align-items-center gap-05">
          <span className={"rounded-full bg-primary-70 px-2"}>{personalDatas.length}</span>
          {isExpanded ? (
            <IconChevronUp width={12} height={12} fill="#171C60" />
          ) : (
            <IconChevronDown width={12} height={12} fill="#171C60" />
          )}
        </div>
      </div>

      {((!isEmpty && isExpanded)) ? (
        <div className="section-content">
          {personalDatas.map((personalData: PersonalData) => (
            <div key={personalData.id} className={`personal-data-card ${getTypeClassName(personalData.type)}`}>
              <div className={"d-flex flex-wrap gap-1 justify-content-center align-items-center"}>
                <div className="personal-data-value">
                  {maskValue(personalData.type, personalData.value)}
                </div>
                {personalData.isDataBreached && (
                  <div
                    onClick={() => {
                      if (personalData.type === 'email') {
                        return navigate(`/particuliers/fuites-donnees?email=${encryptApiBodyFromStringWordPress(personalData.value?.trim())}`);
                      }
                    }}
                    className={"d-flex bg-light py-1 px-2 rounded-lg gap-05 flex-row justify-content-center align-items-center pointer hover:shadow"}>
                  <IconVirusSmall width={15} height={15} />
                  <span className={"bold text-sm text-error-40 rounded-lg bg-accent-70 p-1 px-2"}>
                    {getBreachCountForValue('email', personalData.value?.trim(), breaches)}
                  </span>
                    <span className={'text-muted-foreground text-sm'}>fuites</span>
                </div>
                )}
              </div>
              <div className="personal-data-actions">
                <Button
                  isIconButton={true}
                  onClick={() => onEdit && onEdit(personalData)}
                  type={Button_Type.SECONDARY}
                  style={Button_Style.OUTLINED}
                  icon={<IconEdit width={14} height={14} />}
                  className="personal-data-edit"
                  aria-label="Modifier"
                />
                <Button
                  isIconButton={true}
                  onClick={() => onDelete && onDelete(personalData?.id ?? 0)}
                  type={Button_Type.Error}
                  style={Button_Style.OUTLINED}
                  icon={<IconTrash width={14} height={14} />}
                  className="personal-data-delete"
                  aria-label="Supprimer"
                />
              </div>
            </div>
          ))}
        </div>
      ) :  ( isExpanded && (<div className="empty-section-content">
          <p className="empty-message">{emptyMessage}</p>
          {showProtectButton && (
            <div className="protect-button-container">
              <button className="btn-protect-document" onClick={() => onAdd && onAdd()}>
                AJOUTER +
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


interface PiecesIdentiteNewComponentProps {
  isFromDashboard?: boolean;
}
const PiecesIdentiteNewComponent: FC<PiecesIdentiteNewComponentProps> = ({isFromDashboard = false}) => {
  const [activeTab, setActiveTab] = useState<string>("TOUS");

  const { allDocuments, refreshOnlyTheDocuments } = useContext(DocumentsContext);
  const { personalDatas, grouped: groupedPersonalDatas, refreshPersonalDatas, deletePersonalData } = useContext(PersonalDataContext);
  const { breaches, refreshBreaches, getBreaches, checkNewBreaches } = useContext(BreachesContext);

  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const [selectedRows, setSelectedRows] = useState<DocumentUnion[]>([]);
  const [selectedRowsPersonalData, setSelectedRowsPersonalData] = useState<PersonalData[]>([]);
  const [showModalAddPersonalData, setShowModalAddPersonalData] = useState<boolean>(false);
  const [isForBreach, setIsForBreach] = useState<boolean>(false);
  const [editingPersonalData, setEditingPersonalData] = useState<PersonalData | undefined>(undefined);

  const handleSelectionChange = (rows: DocumentUnion[]) => {
    setSelectedRows(rows);
  };

  const handleSignalerFuite = () => {
    setShowModalPwned(false);
    setIsForBreach(true);
    setShowModalAddPersonalData(true);
  };

  const handleSelectionPersnalData = (id: number) => {
    setPersonalDataSelectedId(id);
    setShowModalDeltePersonalData(true)
  };

  const handleAddPersonalData = (dataToEdit?: PersonalData) => {
    setEditingPersonalData(dataToEdit);
    setShowModalAddPersonalData(true);
  };

  const handleEditPersonalData = (personalData: PersonalData) => {
    setEditingPersonalData(personalData);
    setShowModalAddPersonalData(true);
  };

  const handleDeletePersonalData = async (id: number) => {
    try {
      await deletePersonalData(id);
      await refreshPersonalDatas();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
    }
    setShowModalDeltePersonalData(false);
  };

  const [showModalExp, setShowModalExp] = useState<boolean>(false);
  const [showExpiredSpan, setShowExpiredSpan] = useState<boolean>(true);
  const [showPwnedSpan, setShowPwnedSpan] = useState<boolean>(true);
  const [showModalPwned, setShowModalPwned] = useState<boolean>(false);
  const [showModalDeltePersonalData, setShowModalDeltePersonalData] = useState<boolean>(false);
  const [personalDataSelectedId, setPersonalDataSelectedId] = useState<number | null>();

  useEffect(() => {
    getBreaches();
    checkNewBreaches().then((value) => {
      setShowPwnedSpan(true);
      setShowModalPwned(value);
    })
    refreshBreaches()
  }, [location.pathname]);

  useEffect(() => {
    if (allDocuments) {
      setIsLoading(false);
    }
    refreshOnlyTheDocuments();
  }, [location.pathname, allDocuments.length]);

  useEffect(() => {
    refreshPersonalDatas()
  }, [location.pathname]);

  const toggleSection = (sectionKey: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  // Fonction pour mapper le type de document
  const getDocumentTypeKey = (document: DocumentUnion): string => {
    const type = document.type?.toLowerCase();

    if (formatDocumentType(type) === "Carte d'identité") return 'CARTE_IDENTITE';
    if (formatDocumentType(type) === "Passeport") return 'PASSEPORT';
    if (formatDocumentType(type) === "Carte de séjour") return 'TITRE_SEJOUR';
    if (formatDocumentType(type) === "Permis de conduire") return 'PERMIS_CONDUIRE';
    return 'AUTRES';
  };

  // Filtrer les documents selon l'onglet actif
  const getFilteredDocuments = () => {
    switch (activeTab) {
      case 'DOCUMENTS_ACTIFS':
        return allDocuments.filter(doc => doc?.status?.toUpperCase() === 'SUIVI');
      case 'DOCUMENTS_INACTIFS':
        return allDocuments.filter(doc => doc.status !== 'SUIVI');
      default:
        return allDocuments;
    }
  };

  const getFilteredExpiredDocuments = () => {
    return allDocuments.filter(doc => {
      if (joursRestants(doc?.dateExpiration) && joursRestants(doc?.dateExpiration)!.jours <= 60) {
        return true;
      } else {
        return false
      }
    });
  };

  // Regrouper les documents par type
  const groupDocumentsByType = () => {
    const filteredDocs = getFilteredDocuments();
    const grouped: {[key: string]: DocumentUnion[]} = {};

    Object.keys(DOCUMENT_TYPES).forEach(key => {
      grouped[key] = [];
    });

    filteredDocs.forEach(doc => {
      const typeKey = getDocumentTypeKey(doc);
      if (grouped[typeKey]) {
        grouped[typeKey].push(doc);
      }
    });

    return grouped;
  };

  const groupedDocuments = groupDocumentsByType();

  // État des sections expansées - MIS À JOUR pour inclure tous les types
  const [expandedSections, setExpandedSections] = useState<{[key: string]: boolean}>({
    'CARTE_IDENTITE': (groupedDocuments['CARTE_IDENTITE'] || []).length > 0 && getFilteredDocuments().length > 0,
    'PASSEPORT': (groupedDocuments['PASSEPORT'] || []).length > 0 && getFilteredDocuments().length > 0,
    'TITRE_SEJOUR': (groupedDocuments['TITRE_SEJOUR'] || []).length > 0 && getFilteredDocuments().length > 0,
    'PERMIS_CONDUIRE': (groupedDocuments['PERMIS_CONDUIRE'] || []).length > 0 && getFilteredDocuments().length > 0,
    'email': (groupedPersonalDatas?.email || []).length > 0,
    'phoneNumber': (groupedPersonalDatas?.phoneNumber || []).length > 0,
    'iban': (groupedPersonalDatas?.iban || []).length > 0,
    'address': (groupedPersonalDatas?.address || []).length > 0,
    'socialSecurityNumber': (groupedPersonalDatas?.socialSecurityNumber || []).length > 0,
    'password': (groupedPersonalDatas?.password || []).length > 0,
  });

  const BtnRowsActions = ({ className, btnClassName }: any) => {
    return (
      <div className={className}>
        <SelectedRowsActions
          btnClassName={btnClassName}
          isSelected={selectedRows.length > 0}
          documents={selectedRows}
          onSelectionChange={handleSelectionChange}
        />
      </div>
    );
  };

  const BtnAddPersonalData = ({ className, btnClassName }: any) => {
    return (
      <div className={className}>
        <Button
          label="Ajouter"
          size={btnClassName? undefined : "M"}
          onClick={() => handleAddPersonalData()}
          icon={<IconAdd
            fill={"#148c48"}
            height={15}
            className={`PageHeader__icon`}
            width={15}
          />}
          className={`d-flex justify-content-center align-items-center flex-reverse ${btnClassName}`}
        />
      </div>
    );
  };

  // Liste de tous les types de données personnelles
  const personalDataTypes: PersonalDataType[] = ['email', 'phoneNumber'];

  return (
    <>
      <div className="PiecesIdentiteNew mb-20">
        <div className="content-grid">
          <div className="main-content">
            {!isFromDashboard && (
              <>
                <div className="content-header">
                  <div className={"d-flex flex-row gap-1 justify-content-center align-items-center"}>
                    <div className={"d-flex flex-column"}>
                      <span className={"text-primary bold"}>Document d’identité</span>
                      <span className={"text-xs text-muted-foreground"}>
                        {allDocuments?.length} document{`${allDocuments?.length > 1 ? "s " : " "}`}
                        protégé{`${allDocuments?.length > 1 ? "s " : " "}`}
                      </span>
                    </div>
                  </div>
                  {!isMobile && <BtnRowsActions />}
                </div>
              </>
            )}

            {(getFilteredExpiredDocuments().length >= 1 && showExpiredSpan) && (
              <div
                className={"my-1 bg-neutral-70 d-flex flex-row justify-content-between align-items-center px-8 py-2"}>
                <div className={"d-flex flex-row flex-wrap gap-1 justify-content-center align-items-center"}>
                  <div
                    className={"d-flex bg-light py-1 px-2 rounded-lg gap-05 flex-row justify-content-center align-items-center"}>
                    <IconCalendarSmall fill="#FF5326" width={15} height={15} />
                    <span className={"bold text-sm text-error-40 rounded-lg bg-accent-70 p-1 px-2"}>2 mois</span>
                  </div>
                  <div
                    onClick={() => {
                      setShowModalExp(true);
                    }}
                    className={"d-flex flex-row flex-wrap justify-content-center align-items-center gap-05"}>
                    <span className={"text-muted-foreground text-xs pointer hover:shadow"}>
                      {getFilteredExpiredDocuments().length}
                      {`${getFilteredExpiredDocuments().length > 1 ? " documents arrivent " : " document arrive "}`}
                      bientôt à expiration
                    </span>
                    <span
                      className={"underline text-secondary-50 text-sm pointer"}
                    >
                    Afficher</span>
                  </div>
                </div>
                <div>
                  <IconClose
                    fill={"#171C60"}
                    height={12}
                    width={12}
                    className={"pointer"}
                    onClick={() => {
                      setShowExpiredSpan(false);
                    }}
                  />
                </div>
              </div>
            )}

            {isLoading && (
              <div className="loading-container">
                <EmptyContent
                  text="Chargement, veuillez patienter, un instant..."
                  showIcon={false}
                />
              </div>
            )}

            {!isLoading && (
              <div className="sections-container">
                {/* Section Carte d'identité */}
                <DocumentSection
                  title="Carte d'identité"
                  icon={<IconCardIdSmall width={15} height={15} />}
                  documents={groupedDocuments["CARTE_IDENTITE"] || []}
                  isExpanded={expandedSections["CARTE_IDENTITE"]}
                  onToggle={() => toggleSection("CARTE_IDENTITE")}
                  isEmpty={(groupedDocuments["CARTE_IDENTITE"] || []).length === 0}
                  emptyMessage="Si vous avez une carte d'identité, Elle semble ne pas avoir encore été ajoutée et protégée par nos outils"
                  selectedRows={isFromDashboard ? [] : selectedRows}
                  onSelectionChange={handleSelectionChange}
                  selectable={!isFromDashboard}
                />

                {/* Section Passeport */}
                <DocumentSection
                  title="Passeport"
                  icon={<IconPassportSmall width={15} height={15} />}
                  documents={groupedDocuments["PASSEPORT"] || []}
                  isExpanded={expandedSections["PASSEPORT"]}
                  onToggle={() => toggleSection("PASSEPORT")}
                  isEmpty={(groupedDocuments["PASSEPORT"] || []).length === 0}
                  emptyMessage="Si vous avez un passeport, il semble ne pas avoir encore été ajouté et protégé par nos outils"
                  showProtectButton={false}
                  selectedRows={isFromDashboard ? [] : selectedRows}
                  onSelectionChange={handleSelectionChange}
                  selectable={!isFromDashboard}
                />

                {/* Section Permis de conduire */}
                <DocumentSection
                  title="Permis de conduire"
                  icon={<IconDriverLicenceSmall width={15} height={15} />}
                  documents={groupedDocuments["PERMIS_CONDUIRE"] || []}
                  isExpanded={expandedSections["PERMIS_CONDUIRE"]}
                  onToggle={() => toggleSection("PERMIS_CONDUIRE")}
                  isEmpty={(groupedDocuments["PERMIS_CONDUIRE"] || []).length === 0}
                  emptyMessage="Si vous avez un permis de conduire, il semble ne pas avoir encore été ajouté et protégé par nos outils"
                  selectedRows={isFromDashboard ? [] : selectedRows}
                  onSelectionChange={handleSelectionChange}
                  selectable={!isFromDashboard}
                />

                {/* Section Titre de séjour */}
                <DocumentSection
                  title="Titre de séjour"
                  icon={<IconResidencyPermitSmall width={15} height={15} />}
                  documents={groupedDocuments["TITRE_SEJOUR"] || []}
                  isExpanded={expandedSections["TITRE_SEJOUR"]}
                  onToggle={() => toggleSection("TITRE_SEJOUR")}
                  emptyMessage="Si vous avez un titre de séjour, il semble ne pas avoir encore été ajouté et protégé par nos outils"
                  isEmpty={(groupedDocuments["TITRE_SEJOUR"] || []).length === 0}
                  selectedRows={isFromDashboard ? [] : selectedRows}
                  onSelectionChange={handleSelectionChange}
                  selectable={!isFromDashboard}
                />
              </div>
            )}

            {isMobile && <BtnRowsActions className="w-100 p-3" btnClassName={"w-100"}/>}
          </div>

          <div className="main-content">
            {!isFromDashboard && (
              <>
                <div className="content-header">
                  <div className={"d-flex flex-row gap-1 justify-content-center align-items-center"}>
                    <div className={"d-flex flex-column"}>
                      <span className={"text-primary bold"}>Données personnelles</span>
                      <span className={"text-xs text-muted-foreground"}>
                        {personalDatas.length ?? 0} données protégées
                      </span>
                    </div>
                  </div>
                  <div>
                    {!isMobile && <BtnAddPersonalData/>}
                  </div>
                </div>
              </>
            )}

            {(breaches.length >= 1 && showPwnedSpan) && (
              <div
                className={"my-1 bg-neutral-70 d-flex flex-row justify-content-between align-items-center px-8 py-2"}>
                <div className={"d-flex flex-row flex-wrap gap-1 justify-content-center align-items-center"}>
                  <div
                    className={"d-flex bg-light py-1 px-2 rounded-lg gap-05 flex-row justify-content-center align-items-center"}>
                    <IconVirusSmall width={15} height={15} />
                    <span className={"bold text-sm text-error-40 rounded-lg bg-accent-70 p-1 px-2"}>{breaches.length}</span>
                  </div>
                  <div
                    onClick={() => {
                      setShowModalPwned(true);
                    }}
                    className={"d-flex flex-row flex-wrap justify-content-center align-items-center gap-05"}>
                    <span className={"text-muted-foreground text-xs pointer hover:shadow"}>
                      {breaches.length}
                      {`${breaches.length > 1 ? ' fuites ' : ' fuite '}`}
                      de données détectée
                    </span>
                    <span
                      className={"underline text-secondary-50 text-sm pointer"}
                    >
                    Afficher</span>
                  </div>
                </div>
                <div>
                  <IconClose
                    fill={"#171C60"}
                    height={12}
                    width={12}
                    className={"pointer"}
                    onClick={() => {setShowPwnedSpan(false)}}
                  />
                </div>
              </div>
            )}

            {isLoading && (
              <div className="loading-container">
                <EmptyContent
                  text="Chargement, veuillez patienter, un instant..."
                  showIcon={false}
                />
              </div>
            )}

            {!isLoading && (
              <div className="sections-container">
                {/* Sections pour tous les types de données personnelles */}
                {personalDataTypes.map((type) => {
                  const dataKey = `${type}` as keyof typeof groupedPersonalDatas;
                  const personalDataList = groupedPersonalDatas?.[dataKey] || [];
                  const isExpanded = expandedSections[type];

                  return (
                    <PersonalDataSection
                      key={type}
                      title={PERSONAL_DATA_TITLES[type]}
                      icon={PERSONAL_DATA_ICONS[type]}
                      personalDatas={personalDataList}
                      isExpanded={isExpanded}
                      onToggle={() => toggleSection(type)}
                      isEmpty={personalDataList.length === 0}
                      emptyMessage={PERSONAL_DATA_EMPTY_MESSAGES[type]}
                      showProtectButton={true}
                      breaches={breaches}
                      selectable={!isFromDashboard}
                      onSelectionChange={() => {}}
                      selectedRows={[]}
                      onAdd={() => handleAddPersonalData()}
                      onEdit={handleEditPersonalData}
                      onDelete={handleSelectionPersnalData}
                    />
                  );
                })}
              </div>
            )}
            {isMobile && <BtnAddPersonalData className="w-100 p-3" btnClassName={"w-100"}/>}
          </div>
        </div>

        <div className={"row"}>
          {/* Section FAQ */}
          <div className="col-sm-6">
            <FAQ
              initialDisplayCount={3}
              title="FAQ"
              showViewAll={true}
              faqData={faqDataIDTracker}
            />
          </div>
          <div className="col-sm-6 card d-flex flex-column w-100">
            <div className="text-secondary">
              <div className="d-flex flex-column gap-3">
                <div className="text-primary text-mm bold">
                  Plateforme ID Protect en vidéo
                </div>
                <div
                  className={"text-sm text-muted-foreground d-flex flex-row flex-wrap justify-content-start align-items-center gap-1"}
                >
                  <TutorialCard
                    image={coverIDTrackerVideo1}
                    alt={'ID Protect'}
                    videoUrl="https://youtu.be/XvoHvSI-Huo?si=2wVWL9WpdIH-01Hp"
                    width={200}
                    videoTitle={"La plateforme ID Protect"}
                    videoSubTilte={'Découvrez le fonctionnement de la 1ère plateforme qui vous protège contre l\'usurpation d\'identité'}
                  />
                  <TutorialCard
                    image={coverIDTrackerVideo2}
                    alt={'ID Protect'}
                    videoUrl="https://www.youtube.com/watch?v=01yuOjLWPHs"
                    width={200}
                    videoTitle={"Nos outils de prévention"}
                    videoSubTilte={'ID Protect - Nos outils de prévention contre l\'usurpation d\'identité'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModalExp &&
          <Modal
              onClose={() => setShowModalExp(false)}
              isOpen={showModalExp}
              title={"Documents expirant bientôt"}
              infoModal={true}
              type={"info"}
              logo={<IconCalendar2Small width={15} height={15} />}
              subtitle={`${getFilteredExpiredDocuments().length} document(s) bientôt à expiration`}
          >
              <div className="section-content">
                {isMobile ? (
                  <div className="mobile-content">
                    {getFilteredExpiredDocuments().map((document: DocumentUnion) => (
                      <div key={document.id} className="document-card-wrapper">
                        <DocumentCard document={document} hideTypeDoc={true} showRemainDateExp={true} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="desktop-content">
                    <Table
                      columns={columnsForExp}
                      rows={getFilteredExpiredDocuments()}
                      size="sm"
                      selectedRows={isFromDashboard ? [] : selectedRows}
                      onSelectionChange={handleSelectionChange}
                      selectable={false}
                    />
                  </div>
                )}
              </div>
          </Modal>
      }

      {showModalPwned &&
          <Modal
              onClose={() => setShowModalPwned(false)}
              isOpen={showModalPwned}
              title={"Fuite de données"}
              subtitle={`ID Protect a découvert`}
              labelOnConfirm={"Signaler une fuite"}
              onConfirm={handleSignalerFuite}
              type={"info"}
              logo={<IconCalendar2Small width={15} height={15} />}
              bgBody={"bg-primary-70 px-10"}
          >
              <div className="section-content">
                  <Timeline breaches={breaches} showDescription={false}/>
              </div>
          </Modal>
      }

      {showModalDeltePersonalData &&
          <Modal
              onClose={() => setShowModalDeltePersonalData(false)}
              isOpen={showModalPwned}
              title={"Suppression"}
              type={"info"}
              confirmButtonDisabled={false}
              labelOnConfirm={"Supprimer"}
              onConfirm={() => handleDeletePersonalData(personalDataSelectedId?? 0)}
              logo={<IconTrash width={15} height={15} fill={"#FF5326"} />}
              bgBody={"bg-primary-70 px-10"}
          >
              <div className="section-content">
                  <div>Voulez-vous vraiment supprimer ?</div>
              </div>
          </Modal>
      }

      {showModalAddPersonalData && (
        <ModalAddNewPersonalData
          isForBreach={isForBreach}
          isOpen={showModalAddPersonalData}
          onClose={() => {
            setShowModalAddPersonalData(false);
            setEditingPersonalData(undefined);
            setIsForBreach(false)
          }}
          personalData={editingPersonalData}
        />
      )}
    </>
  );
};

export default PiecesIdentiteNewComponent;